export default __webpack_public_path__ + "static/hospitality-09f772f17b2d5377d4e9172a2bc696ad.jpg";